import React from "react";
import Navbar from "./Navbar";
import FooterSection from "./footersection";
import "./terms_of_service_page.css";
import TermsOfServiceContent from "./term_of_service_content";


const TermsOfServicePage =  () =>{
    return(
        <div>
            <Navbar hideNav={true}/>
            <TermsOfServiceContent></TermsOfServiceContent>
            <FooterSection/>
        </div>
    );
}

export default TermsOfServicePage;